import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { appointmentExportTypesSchema } from './appointment-export-types';

const c = initContract();

export const adminTranscriptContract = c.router(
  {
    exportTranscriptArtifacts: {
      method: 'POST',
      path: '/export-transcript-artifacts',
      body: z.object({
        includeTags: z.array(z.string()).optional(),
        excludeTags: z.array(z.string()).optional(),
        appointmentTypes: z.array(appointmentExportTypesSchema).optional(),
        tenantId: z.string().uuid(),
        userIds: z.array(z.string().uuid()).optional(),
      }),
      responses: {
        201: z.boolean(),
      },
    },
    exportTranscriptArtifactsByAppointmentIds: {
      method: 'POST',
      path: '/export-transcript-artifacts-by-appointment-ids',
      body: z.object({
        appointmentIds: z.array(z.string().uuid()),
        tenantId: z.string().uuid(),
      }),
      responses: {
        201: z.boolean(),
      },
    },
  },
  { pathPrefix: '/admin-transcript' },
);
